module.exports = __webpack_public_path__ + "static/img/live-bg.6d19a7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/article/live-bg.png
// module id = EC+1
// module chunks = 1